import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { generateSampleDetailsParams } from '@features/filter/static/filterUtil';
import SampleVIewForOthers from '@features/sampleDevelopment/components/SampleVIewForOthers';
import SampleViewForSampleDepartment from '@features/sampleDevelopment/components/SampleViewForSampleDepartment';

import { clearDetailsPageGlobalFilter, handleFilterOfListPage } from '@store/actions/FilterAction';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { fetchDependentFilterList } from '@services/commonService';

import { isPatternMaster, isSampleOrProductHead } from '@utils/Util';

const SampleView = () => {
	const dispatch = useDispatch();
	const filterfields = useSelector((store) => store.filterFieldStore);
	const { id } = useParams();
	const { ...paramsData } = generateSampleDetailsParams(filterfields);

	useEffect(() => {
		window.scrollTo(0, 0);
		dispatch(openLoader());
		Promise.all([
			dispatch(
				fetchDependentFilterList({ type: 'SAMPLE_DETAILS', idUrl: `${id}/filter/all` }, paramsData)
			),
			dispatch(
				handleFilterOfListPage({ type: 'sampleDetailsAction', idUrl: `${id}` }, paramsData, false)
			)
		]).finally(() => dispatch(closeLoader()));
	}, [filterfields]);

	useEffect(() => {
		return () => {
			dispatch(clearDetailsPageGlobalFilter());
		};
	}, []);

	{
		return isSampleOrProductHead() || isPatternMaster() ? (
			<SampleViewForSampleDepartment />
		) : (
			<SampleVIewForOthers />
		);
	}
};

export default SampleView;
